import * as React from 'react';
import styled from 'styled-components';
import { borderGrey, labelGrey, textGrey } from '../appComponents/cssConstants';
import PrimaryButton, { ButtonProps } from './PrimaryButton';

const SecondaryButton = (props: ButtonProps) => {
	const { type = 'button', text = 'Back', disabled = false, fullWidth = false, onClick, className } = props;
	return (
		<StyledButton
			type={type}
			text={text}
			disabled={disabled}
			onClick={onClick}
			fullWidth={fullWidth}
			className={className}
		/>
	);
};

export default SecondaryButton;

const StyledButton = styled(PrimaryButton)`
	color: ${labelGrey};
	background-color: white;
	border: 1px solid ${borderGrey};
	margin: 0;

	&:hover {
		border-color: ${labelGrey};
		color: ${textGrey};
		background-color: white;
	}
`;
